// extracted by mini-css-extract-plugin
export default {"gauge":"DespesaPessoal_gauge__dckrc","rectangle":"DespesaPessoal_rectangle__GpvKu","seletor-instituicao":"DespesaPessoal_seletor-instituicao__W2ZDD"};